/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";
import logo from "../../assets/img/logo.png"; // Corrected import

const Sidebar = ({ open, onClose }) => {
  const isAdmin = sessionStorage.getItem("isAdmin");
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full w-[290px] flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span className="absolute top-4 right-4 block cursor-pointer xl:hidden" onClick={onClose}>
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[30px] mb-[30px] text-center`}>
        <div>
          <img src={logo} alt="" />
        </div>
        <div className="font-poppins text-[20px] font-bold  text-navy-700 dark:text-white">
          {/* Plistbooking */}
          <hr />
          <p className="text-[16px] text-gray-700">{isAdmin == "true" ? "Super Admin" : "Admin"}</p>
        </div>
      </div>
      <div className="mt-[30] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>
      <div className="flex justify-center">
        <SidebarCard />
      </div>
    </div>
  );
};

export default Sidebar;
